import { Navigate, useLocation } from "react-router";
import { useAuth } from "./auth-provider";

interface GuardProps {
  children: React.ReactNode;
  allowedRoles: ('SUPER' | 'ADM' | 'RESPONSAVEL' | 'PROFESSOR' | 'ALUNO')[];
  allowSuperWithoutSchool?: boolean;
}

export const Guard = ({ children, allowedRoles, allowSuperWithoutSchool = false }: GuardProps) => {
  const { identity } = useAuth();
  const location = useLocation();

  const selectedRole = identity?.selected_role || identity?.role;

  if (!identity || !allowedRoles.includes(selectedRole as any)) {
    return <Navigate to="/" replace />;
  }

  const isSuperSemEscola = identity?.role === 'SUPER' && !identity.school_id;
  if (isSuperSemEscola && !allowSuperWithoutSchool && location.pathname !== '/') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
